import { render, staticRenderFns } from "./SubmittedDocumentsModal.vue?vue&type=template&id=753edf94&scoped=true&"
import script from "./SubmittedDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./SubmittedDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedDocumentsModal.vue?vue&type=style&index=0&id=753edf94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753edf94",
  null
  
)

export default component.exports